// Analytics utility functions
declare global {
  interface Window {
    gtag: (command: string, action: string, params: any) => void;
  }
}

// Track page views
export const trackPageView = (path: string, title: string): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title,
    });
  }
};

// Track user interactions
export const trackEvent = (category: string, action: string, label?: string, value?: number): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user engagement
export const trackEngagement = (type: string, duration?: number): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'user_engagement', {
      engagement_type: type,
      engagement_duration: duration,
    });
  }
};

// Track content interaction
export const trackContentInteraction = (contentType: string, action: string): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'content_interaction', {
      content_type: contentType,
      interaction_type: action,
    });
  }
};

// Track download events
export const trackDownload = (fileName: string, fileType: string): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'file_download', {
      file_name: fileName,
      file_type: fileType,
    });
  }
};

// Track form interactions
export const trackFormInteraction = (formName: string, action: string): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'form_interaction', {
      form_name: formName,
      interaction_type: action,
    });
  }
};

// Track video interactions
export const trackVideoInteraction = (videoName: string, action: string): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'video_interaction', {
      video_name: videoName,
      interaction_type: action,
    });
  }
};

// Track scroll depth
export const trackScrollDepth = (depth: number): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'scroll_depth', {
      depth: depth,
    });
  }
};

// Track time on page
export const trackTimeOnPage = (timeInSeconds: number): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'time_on_page', {
      time_in_seconds: timeInSeconds,
    });
  }
};

// Track user type
export const trackUserType = (userType: string): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('set', 'user_type', userType);
  }
};

// Track content category
export const trackContentCategory = (category: string): void => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('set', 'content_category', category);
  }
}; 